export default __webpack_public_path__ + "static/media/Done.f90e9040.svg";